/**
 * ============================================================
 * ProjectCardCompact.js — Compact Card for Projects
 * ============================================================
 *
 * Props:
 *   project: {
 *     id,
 *     shortname,
 *     photo
 *   }
 *
 * Used in:
 *   -> Projects.js (past project list)
 *   -> Person.js (projects)
 **/

import React from "react";
import { Link } from "react-router-dom";
import "./css/ProjectCardCompact.css";

import { projectPhoto } from "../utils/mediaPaths";

// ------------------------------------------------------------
// Component
// ------------------------------------------------------------
function ProjectCardCompact({ project }) {
  const { id, shortname, photo } = project;

  // Photo path
  const photoSrc = projectPhoto(photo);

  return (
    <Link to={`/projects/${id}`} className="project-card-compact-link">
      <div className="project-card-compact">

        {/* ----- IMAGE ----- */}
        <div className="project-card-compact-image-wrapper">
          <img
            className="project-card-compact-image"
            src={photoSrc}
            alt={project.name || shortname}
          />
        </div>

        {/* ----- TITLE ----- */}
        <h3 className="project-card-compact-title">{shortname}</h3>

      </div>
    </Link>
  );
}

export default ProjectCardCompact;